<!-- <header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo"> 
        <h5>Registro Usuarios forma Masiva.</h5>
    </div>
</header> -->
<div class="content-header">
    <h2>Registro Usuarios forma Masiva.</h2>
</div>
@if(loading){
<div class="loading-overlay">
    <div class="loading-indicator">Registrando autoridades...</div>
</div>
}
<div class="container-fluid">
    <div class="justify-content-center min-vh-100 bg-light p-3 ">
        <div class="excel-container">
            <oaj-alert-itx></oaj-alert-itx>
            <form [formGroup]="formReg" novalidate>
                <div class="card shadow-sm" style=" width: 100%;">
                    <div class="card-body">
                        <label class="form-label mb-1" for="tipoOrganismoSelect">Selección de dependencia</label>
                        <div class="d-flex align-items-center gap-2 contenedorSelect">
                            <ng-select id="tipoDependenciaSelect" name="tipoDependenciaSelect" style="width: 100%;"
                                [items]="(catDep$ | async)?.data!" bindLabel="nombre" [minTermLength]="3"
                                [trackByFn]="trackByFn" typeToSearchText="Para buscar escriba 3 o mas caracteres"
                                bindValue="catTipoOrganismoId" [loading]="catDeploading" [typeahead]="catDepInput$"
                                formControlName="dependencia"
                                placeholder="Seleccione la denominación de su dependencia">
                            </ng-select>
                        </div>

                        <div class="upload-container mt-3">
                            <label for="file-input" class="upload-button">
                                <!-- Icon Placeholder (e.g., Font Awesome) -->
                                <i class="fas fa-cloud-upload-alt upload-icon"></i>
                                <!-- Spanish Text -->
                                <span>Seleccionar Archivo</span>
                            </label>

                            <input id="file-input" type="file" (change)="onFileSelected($event)" style="display: none;"
                                accept=".xlsx,.xls" />
                        </div>
                        @if(fileName){
                        <p>{{ 'Archivo seleccionado: ' + fileName }}</p>
                        }

                    </div>
                </div>


                @if(data.length)
                {
                <div class="row mt-3">
                    <label for="submit-btn" class="col-md-2">Previsualización de datos Excel:</label>
                    <div class="col-6">
                        <button id="submit-btn" class="btn btn-login" type="submit" [disabled]="loading"
                            (click)="onSubmit()">Inicia
                            proceso de Carga</button>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <!-- Loop through headers for column titles -->
                                    @for ( header of headers; track $index) {
                                    <th>{{ header }}</th>
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                <!-- Loop through data for rows -->
                                @for(item of data; track $index) {
                                <tr>
                                    <!-- Loop through headers again to display corresponding values for each row -->
                                    @for(header of headers; track $index){
                                    <td>
                                        {{ item[header] }}
                                    </td>
                                    }

                                </tr>
                                }

                            </tbody>
                        </table>

                    </div>
                </div>
                }

            </form>
        </div>

    </div>
</div>